<template>
  <div>
    <div class="meeting-list-div-title bt-top-div">
      <div style="display: flex;justify-content: center;align-items: flex-end;">
        <img src="../../../public/img/loneline.png">
        <img style="margin-left: 2px;" class="list-div-short-line" src="../../../public/img/shortline.png">
        <span class="div-list-title bt-top-title">公告详情</span>
      </div>
    </div>
    <div class="bt-content-div">
      <div class="bt-content-info">
        <span class="bt-content-info-title">
          {{bulletinData.title}}
        </span>
        <div style="display: flex;justify-content: flex-end;align-items: flex-end;">
          <span class="item-bottom-out-span">
            <span class="item-bottom-time">{{bulletinData.publishTime}}</span>
          </span>
        </div>
      </div>
      <div class="bt-content-name">详情介绍：</div>
      <div class="bt-content-detail">
        <span v-html="bulletinData.content"></span>
      </div>
    </div>
    <div style="height: 20px;"></div>
    <rightFixed />
  </div>
</template>

<script>
import { getDetail as winDetail } from "@/api/biz/auction/winBulletin";
import { getDetail as changeDetail } from "@/api/biz/auction/changeBulletin";
import rightFixed from '@/components/rightFixd'
import { getLazyTree } from "@/api/base/region";
import { getBizDictByCode } from '@/api/system/dict'
export default {
  name: 'BulletinView',
    components: { rightFixed },
  data() {
    return {
      bulletinData: {},
      page: {
        pageSize: 100,
        currentPage: 1,
        total: 0
      },
      address:'',
      bulletinId:'',
      bulletinTypeDict: [],
      treeArr:[],
      bulletinType: 4,
    }
  },
  async created() {
    const storeTree = localStorage.getItem('Tree');
    if (storeTree && storeTree.length != 0) {
      this.treeArr = JSON.parse(storeTree);
    } else {
      this.getTree()
    }
    await this.getBulletinType();
    this.address = this.$route.query.address
    this.bulletinId= this.$route.query.bulletinId
    this.bulletinType=this.$route.query.bulletinType
    await this.queryData();
  },
  methods: {
    getBulletinType() {
      getBizDictByCode('bulletin_type').then(res => {
        this.bulletinTypeDict = res.data.data;
        this.bulletinTypeDict.unshift({ id: 111, dictValue: '全部', dictKey: null, sort: 0 })
      });
    },
    formatDataType(type) {
      let data = '';
      this.bulletinTypeDict.forEach(ele => { if (ele.dictKey == type) data = ele.dictValue; })
      return data;
    },
    getTree() {
      getLazyTree().then(res => {
        this.treeArr = res.data.data
      })
    },
    mapTree(tree, path) {
      if(!tree||!path){
        return;
      }
      const keys = path.split(',');
      let currentNode = tree;
      const regionNames = [];
      let count = 0;
      for (const key of keys) {
        const region = currentNode.find(item => {
          const ids = item.id.split(',');
          return ids.includes(key);
        });
        if (region) {
          regionNames.push(region.title);
          count++;
          if (count === 2) {
            break;
          }
          currentNode = region.children;
        } else {
          break;
        }
      }
      return regionNames.join('-');
    },
    async queryData() {
      if(this.bulletinType==2){
        await changeDetail(this.bulletinId).then(res => {
          const data = res.data.data;
          this.page.total = data.total;
          this.bulletinData = data;
        });
      }else if(this.bulletinType==3){
        await winDetail( this.bulletinId ).then(res => {
          const data = res.data.data;
          this.page.total = data.total;
          this.bulletinData = data;
        });
      }
    },
  }
}
</script>

<style scoped>
::v-deep .el-table th.el-table__cell {
  background: rgba(243, 245, 247, 1);
}
.item-bottom-label {
  margin-right: 5px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 20.27px;
  color: rgba(0, 0, 0, 1);
}
.bt-top-div {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.bt-content-detail {
  padding-top: 30px;
  padding-left: 30px;
  padding-bottom: 20px;
  margin-top: 5px;
  margin-left: 30px;
  width: 1180px;
  min-height: 70px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(215, 215, 215, 1);
  overflow: hidden;
}
.bt-content-name {
  margin-top: 20px;
  margin-left: 30px;
  width: 200px;
  height: 21px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20.27px;
  color: rgba(0, 102, 166, 1);
}
.item-bottom-value {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 102, 166, 1);
}
.bt-content-span {
  margin-left: 20px;
  width: 460px;
  margin-top: 18px;
}
.bt-content-info-title {
  display: inline-block;
  margin-top: 23px;
  margin-left: 350px;
  width: 540px;
  height: 27px;
  opacity: 1;
  /** 文本1 */
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 26.06px;
  color: rgba(0, 0, 0, 1);
  text-align: center;
}
.bt-content-info {
  margin-left: 30px;
  width: 1240px;
  height: 106px;
  opacity: 1;
  border-radius: 5px;
  background: rgba(243, 245, 247, 1);
}
.bt-content-div {
  padding-top: 30px;
  padding-bottom: 20px;
  margin-top: 10px;
  width: 1300px;
  min-height: 300px;
  opacity: 1;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}
.bt-top-title {
  margin-top: 10px;
  display: inline-block;
  font-size: 22px;
  margin-left: 4px;
}
</style>